//console.log(tgblCeuFrontend)

var coxToPDF = ($) => {

  const { jsPDF } = window.jspdf;
  window.html2canvas = html2canvas
  //const jsPDF =  new jsPDF();

  if (!window.Tangible) return
  var ajax = window.Tangible.ajax
  var ajaxConfig = window.Tangible.ajaxConfig

  // Global object
  window.coxToPDF = {}

  $(document).ready(function () {
    window.coxToPDF.tgblJsToPDF.constructor()
  })

  window.coxToPDF.tgblJsToPDF = {

    // initialize the code
    constructor: function () {

      // Add events for the group management page
      this.addJsToPDFEvents();
    },


    addJsToPDFEvents: function () {

      const $tgblJsToPDF= this

      $('body').on( 'click','.tgbl_certificate_pdf', { _this:$tgblJsToPDF }, this.downloadPDF);
      $('body').on( 'click','.tgbl_certificate_email_send', { email: 'send', _this:$tgblJsToPDF }, this.downloadPDF);
      $('body').on( 'click','.tgbl_certificate_print', { _this:$tgblJsToPDF }, this.printPDF);
    },


    downloadPDF: function (e) {

      let send_email = false
      if(e.data !== undefined && (e.data.email !== undefined && e.data.email === 'send')){
        send_email = true
      }

      const $_this = e.data._this
      const $this =$(this)

      const modal_actions_parent = send_email ? $('.jquery-modal.blocker.behind').find('.certificate-modal.modal') : $this.parents('.certificate-modal.modal')
      const cert_background = modal_actions_parent.find('.certificate-background')
      const accred_title = $this.attr('data-accred_title')

      modal_actions_parent.css('opacity', '0')

      const matrix = modal_actions_parent.find('.scaled-down').css('transform').split('(')[1].split(')')[0].split(',')// Array(6) [ "0.6", " 0", " 0", " 0.6", " 0", " 0" ]

      const tranform_x_init = matrix[0]
      const tranform_y_init = matrix[3]
      modal_actions_parent.find('.scaled-down').css('transform', 'scale(1, 1)')

      const pdf = new jsPDF('l')

      html2canvas(cert_background[0],{}).then((canvas) => {

        const imgData = canvas.toDataURL('image/jpeg')
        const imageProps = pdf.getImageProperties(imgData)

        const pdfw = pdf.internal.pageSize.getWidth()
        const pdfh = pdf.internal.pageSize.getHeight()

        pdf.addImage(imgData,'PNG', 0, 0, pdfw, pdfh )

        if(!send_email) {
          pdf.save(tgblCeuFrontend.localized.pdf_title_suffix+ accred_title + '.pdf')

        }else{

          const form = $this.parents('.email-pdf-modal.modal').find('.email-pdf-form')

          // validateEmailPdfForm

          const valid= $_this.validateEmailPdfForm(form)
          if(!valid) {
            modal_actions_parent.css('opacity', '1')
            modal_actions_parent.find('.scaled-down').css('transform', 'scale('+tranform_x_init+', '+tranform_y_init+' )')
            modal_actions_parent.parents('.jquery-modal.blocker.current').css('overflow-x', 'hidden')
            return
          }

          // send email
          $_this.sendEmailPDF(form,accred_title,pdf)
        }

        modal_actions_parent.css('opacity', '1')
        modal_actions_parent.find('.scaled-down').css('transform', 'scale('+tranform_x_init+', '+tranform_y_init+' )')
        modal_actions_parent.parents('.jquery-modal.blocker.current').css('overflow-x', 'hidden')
      })
    },


    printPDF: function (e) {

      const cert_id = $(this).attr('data-cert_id')
      const print_wrap=$(this).parents('.certificate-modal').find('#cert_cox_print_wrap');
      const printable_area = print_wrap.find('#'+cert_id);
      const $printSection = document.createElement("div");

      $printSection.id = "printSection";
      document.body.appendChild($printSection);

      $printSection.innerHTML = '<link rel="stylesheet" href="'+tgblCeuFrontend.css_url+'" type="text/css" /><div style="text-align:center;"><div id="cert_cox_wrap" class="certificate-cox-wrap "><div id="'+cert_id+'" class="certificate no-accreditations">'+printable_area.html()+'</div></div></div>';

      window.print();

      setTimeout(function(){$printSection.remove()},1000);
    },


    sendEmailPDF: function (form,accred_title,pdf) {

      // get form data

      const form_data = {
        cert_sender_name : form.find('#cert_form_sender_name').val(),
        cert_sender_email : form.find('#cert_form_sender_email').val(),
        cert_recipient_name : form.find('#cert_form_recipient_name').val(),
        cert_recipient_email : form.find('#cert_form_recipient_email').val(),
        cert_form_message : form.find('#cert_form_message').val(),
      }

      const data = {
        pdf: pdf.output('dataurlstring',{filename: tgblCeuFrontend.localized.pdf_title_suffix + accred_title + '.pdf'}),
        form_data: form_data,
      }
      const response = form.find('.send-response')

      // ajax send email

      ajax('tgbl_send_email_pdf_ajax', data)
        .then(function(res) {

          //console.log('RESPONSE --- ',  res) // RESPONSE ---  false
          if(res === false){
            response.find('.err').html(tgblCeuFrontend.localized.email_not_sent)
          } else if(res === true){
            response.find('.succ').html(tgblCeuFrontend.localized.email_sent)
          }
        })
        .catch(function(err) {
          console.log('error - ',  err)
          response.find('.err').html(tgblCeuFrontend.localized.email_wrong)
        }) // end ajax
    },


    validateEmailPdfForm: function (form) {

      // validate forms data

      form.validate( {
        rules: {
          cert_form_sender_name: {
            required: true,
            normalizer: function( value ) {
              return $.trim( value )
            }
          },
          cert_form_sender_email: {
            required: true,
            normalizer: function( value ) {
              return $.trim( value )
            }
          },
          cert_form_recipient_name: {
            required: true,
            normalizer: function( value ) {
              return $.trim( value )
            }
          },
          cert_form_recipient_email: {
            required: true,
            normalizer: function( value ) {
              return $.trim( value )
            }
          },
        },
      } )
      const valid= form.valid()

      return valid
    },
  }
}

export { coxToPDF }

